import { Row, Radio, Divider, Col } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import FormAlterarSenha from "./FormAlterarSenha";
import { hasClaim } from "shared/helpers/auth-functions";
import DetalhesConta from "./DetalhesConta";
import "./MeusDados.scss";

const MeusDados: React.FC<RouteComponentProps> = () => {
  const loggedUser = useSelector((state: any) => state.users.loggedUser);
  const [selectedTab, setSelectedTab] = useState<string>("details");
  const googleUser = hasClaim("Google", loggedUser);
  const facebookUser = hasClaim("Facebook", loggedUser);
  const { t } = useTranslation();

  const onChangeTab = (e: any) => {
    setSelectedTab(e.target.value);
  };

  return (
    <div className="meus-dados">
      <Row justify="center">
        <Col span={24}>
          <Row>
            <Radio.Group onChange={onChangeTab} value={selectedTab}>
              <Radio.Button value="details">
                {t("pages.MeusDados.details")}
              </Radio.Button>
              <Radio.Button
                value="changePassword"
                style={{ display: googleUser || facebookUser ? "none" : "" }}
              >
                {t("pages.MeusDados.changePassword")}
              </Radio.Button>
            </Radio.Group>
          </Row>

          <Divider style={{ backgroundColor: "#1f1f1f" }} />
          {selectedTab === "details" && <DetalhesConta />}
          {selectedTab === "changePassword" && <FormAlterarSenha />}
        </Col>
      </Row>
    </div>
  );
};
export default MeusDados;
